import React from "react";
import {
  FaClipboardList,
  FaTruck,
  FaCogs,
  FaHeadset,
  FaLock,
  FaSearch,
  FaThLarge,
  FaTags,
} from "react-icons/fa";

const services = [
  {
    icon: <FaClipboardList />,
    title: "Bulk Ordering Made Easy",
    description:
      "Place large-scale grocery orders quickly with our user-friendly platform—designed for retailers, hotels, and food businesses.",
  },
  {
    icon: <FaTruck />,
    title: "Reliable Delivery Network",
    description:
      "Enjoy on-time delivery with live tracking and priority support, ensuring your business stays stocked and stress-free.",
  },
  {
    icon: <FaCogs />,
    title: "Smart Inventory Management",
    description:
      "Manage your regular orders, track stock levels, and set purchase reminders to streamline your supply chain.",
  },
  {
    icon: <FaHeadset />,
    title: "Dedicated Business Support",
    description:
      "Connect with our expert team for order help, custom quotes, or B2B guidance—because your growth is our priority.",
  },
  {
    icon: <FaLock />,
    title: "Secure & Flexible Payments",
    description:
      "Pay with confidence using UPI, cash, cards, and business-friendly payment options—backed by secure transactions and GST invoicing.",
  },
  {
    icon: <FaSearch />,
    title: "Insightful Purchase History",
    description:
      "Track previous orders, monitor spending, and analyze trends to optimize your buying strategy.",
  },
  {
    icon: <FaThLarge />,
    title: "Multi-Category Sourcing",
    description:
      "Access a wide variety of wholesale groceries—including staples, packaged goods, oils, and more—all from one trusted platform.",
  },
  {
    icon: <FaTags />,
    title: "Customized Deals & Discounts",
    description:
      "Unlock exclusive pricing and tailored offers based on your purchase volume and category needs.",
  },
];

const categories = [
  "Bakeries and Cafes",
  "Kirana Stores",
  "Condiments",
  "Rice Traders",
  "General Stores",
];

const Services = () => {
  return (
    <section className="bg-[#F4F9F4] py-16 px-4 md:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <p className="text-gray-500 text-base mb-2">Services</p>
        <h2 className="text-3xl md:text-4xl font-semibold text-[#2E7D32] mb-8">
          Empowering your Business, Delivery at a Time.
        </h2>

        {/* Categories */}
        <div className="flex flex-wrap gap-3 mb-12">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              className={`px-5 py-2.5 rounded-full border text-sm font-medium transition ${
                cat === "All"
                  ? "bg-gradient-to-r from-[#2E7D32] to-[#4CAF50] text-white shadow-md"
                  : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50 hover:text-[#2E7D32]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Services Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#E8F5E9] text-[#2E7D32] mb-5 text-xl shadow-sm">
                {service.icon}
              </div>
              <h3 className="font-semibold text-lg mb-2 text-gray-800">
                {service.title}
              </h3>
              <p className="text-gray-500 text-sm mb-5 leading-relaxed">
                {service.description}
              </p>
              <a
                href="#"
                className="text-[#2E7D32] font-medium text-sm mt-auto hover:underline"
              >
                More details &gt;
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
